import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.filters.channel_no==='wuhanfulu')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: _ctx.filters.channel_distribution,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.channel_distribution) = $event)),
            placeholder: "二级分销渠道"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelList, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.channel_no,
                  label: item.channel_name,
                  value: item.channel_no
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.order_no,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.order_no) = $event)),
        placeholder: "蛋叔订单号",
        style: {"width":"200px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.name) = $event)),
        placeholder: "收货人",
        style: {"width":"200px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: _ctx.filters.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.phone) = $event)),
        placeholder: "用户手机号",
        style: {"width":"200px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        type: "date",
        placeholder: "选择日期",
        modelValue: _ctx.filters.start_time,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.start_time) = $event)),
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        type: "date",
        placeholder: "选择日期",
        modelValue: _ctx.filters.end_time,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.end_time) = $event)),
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _ctx.onBack
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("返回")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _ctx.onSearch
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _ctx.onExport
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.orderList,
      "span-method": _ctx.objectSpanMethod,
      stripe: "",
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        (_ctx.filters.channel_no==='wuhanfulu')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "channel_distribution",
              label: "二级渠道名称"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "paid_at",
          label: "支付时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "info.product_name",
          label: "商品名称"
        }),
        _createVNode(_component_el_table_column, { label: "单价/数量" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString('￥' + (scope.row.info.amount).toFixed(2)) + " / " + _toDisplayString(scope.row.info.quantity), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "收货人信息" }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", null, _toDisplayString(scope.row.info.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "info.status",
          label: "订单状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "info.pay_status",
          label: "支付状态"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_tag, {
                onClick: ($event: any) => (_ctx.onEdit(scope.row.info.id)),
                size: "small"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("订单详情")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "span-method"]),
    _createVNode(_component_Pagination, {
      total: _ctx.total,
      currentPage: _ctx.currentPage,
      onPageChange: _ctx.onPageChange,
      onSizeChange: _ctx.onSizeChange
    }, null, 8, ["total", "currentPage", "onPageChange", "onSizeChange"])
  ]))
}